













































import {
  Component,
  Prop,
  Mixins
} from "vue-property-decorator";
import AbpBase from "../../../lib/abpbase";
import columns from "./columnsHistory";
import DateTimeMixin from "@/components/mixin/date-time-mixin";
import Entity from "@/store/entities/entity";
import AppConsts from "@/lib/appconst";
import _ from "lodash";
import PageRequest from "@/store/entities/page-request";


class Filter extends Entity<number>{
    categoryId:number;
    clientCode:string;
    keyword:string;
}

class PageRequest_ extends PageRequest {
  keyword: string;
  clientCode: string;
  IgnoneIds: any;
}


@Component
export default class SelectModal extends Mixins(AbpBase,DateTimeMixin) {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Number, default: null }) id: any;
  @Prop({ type: Number, default: null }) productId: any;

  pagerequest: PageRequest_ = new PageRequest_();
  data: any = [];
  listAll: any = [];
  clients: any = [];
  Filter: Filter = new Filter();
  categoriesOfClient: [] = [];

  get loading(){
    return this.$store.state.warrantyDurationConfig.loading;
  }

  get pageSize(){
      return this.$store.state.warrantyDurationConfig.pageSize;
  }
  get totalCount(){
      return this.$store.state.warrantyDurationConfig.totalCount;
  }
  get currentPage(){
      return this.$store.state.warrantyDurationConfig.currentPage;
  }
  
  get list(){
    var re = this.$store.state.warrantyDurationConfig.listSelect;
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }

  pageChange(page:number){
      this.$store.commit('warrantyDurationConfig/setCurrentPage',page);
      this.getpage();
  }
  pagesizeChange(pagesize:number){
      this.$store.commit('warrantyDurationConfig/setPageSize',pagesize);
      this.getpage();
  }

  columns = columns;

  onFilter() {
    const values = this.Filter;
    let datas = this.listAll;
    if(!_.isEmpty(values.clientCode) && values.clientCode != '_ALL')
      datas = _.filter(datas, v => v.product.clientCode === values.clientCode)
    if(!_.isNil(values.categoryId) && values.categoryId != -1)
      datas = _.filter(datas, v => v.product.categoryId === values.categoryId)
    if(!_.isEmpty(values.keyword))
      datas = _.filter(datas, v => v.product.sku.includes(values.keyword) || v.product.name.includes(values.keyword))  
    
    var index = 0;
    datas.forEach(function(item) {
      item.orderNo = index + 1;
      index++;
    });
    this.listAll = datas;
  }

  cancel() {
    this.$emit("input", false);
  }

  onAdd(id) {
     this.$store.dispatch({
          type:'warrantyDurationConfig/get',
          data: {
          id,
        },
      }).then(v => { 
        this.$emit('save-add', v.warrantyDurationConfigs)
      })
  }

  visibleChange(value: boolean) {
    this.pagerequest.keyword = '';
    if (!value) {
      this.$emit("input", value);
    } else {
      this.getpage();
    }
  }

  async getpage(){  
    await this.$store.dispatch({
        type:'product/GetProductWarrantyDurationById',
        data: { id: this.id, productId: this.productId },
    }).then(v => {
        var index = 0;
        v.forEach(function(item) {
          item.orderNo = index + 1;
          index++;
        });
        this.listAll = v;
      });
  }

  async changeClientCode() {
    await this.getCategoriesOfClientForSelect();
  }

  async getCategoriesOfClientForSelect() {
    await this.$store
      .dispatch({
        type: "category/getCategoriesByClientForSelect",
        data: { clientCode: this.Filter.clientCode },
      })
      .then(() => {
        var re = this.$store.state.category.categoriesOfClientForSelect;
        re.unshift({ id: -1, name: this.L(AppConsts.All) });
        this.categoriesOfClient = re;
        this.Filter.categoryId = -1;
      });
  }
  async created(){
    this.getClients();
  }

  async getClients() {
    await this.$store
      .dispatch({
        type: "client/getListForSelect",
        data: { hasAllItem: true },
      })
      .then(() => {
        this.clients = this.$store.state.client.clientsForSelect;
      });
  }
}
